import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AboutInfoTabs.css';

const AboutInfoTabs = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('mission');

  const tabContent = {
    mission: {
      title: t('about_info_tabs_mission_title'),
      text: t('about_info_tabs_mission_text'),
      points: [
        t('about_info_tabs_mission_point_1'),
        t('about_info_tabs_mission_point_2'),
        t('about_info_tabs_mission_point_3'),
        t('about_info_tabs_mission_point_4')
      ]
    },
    vision: {
      title: t('about_info_tabs_vision_title'),
      text: t('about_info_tabs_vision_text'),
      points: [
        t('about_info_tabs_vision_point_1'),
        t('about_info_tabs_vision_point_2'),
        t('about_info_tabs_vision_point_3'),
        t('about_info_tabs_vision_point_4')
      ]
    },
    history: {
      title: t('about_info_tabs_history_title'),
      text: t('about_info_tabs_history_text'),
      points: [
        t('about_info_tabs_history_point_1'),
        t('about_info_tabs_history_point_2'),
        t('about_info_tabs_history_point_3'),
        t('about_info_tabs_history_point_4')
      ]
    }
  };

  return (
    <section className="about-info-tabs-section section-padding">
      <div className="container">
        <div className="info-tabs-header fade-up">
          <span className="section-tag">{t('about_info_tabs_section_tag')}</span>
          <h2 className="section-title">{t('about_info_tabs_section_title')}</h2>
        </div>

        <div className="info-tabs-content-wrapper fade-up stagger-1">
          <div className="info-tabs-image">
            <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=600&fit=crop" alt="Team working" />
          </div>

          <div className="info-tabs-details">
            <div className="tabs-nav">
              <button 
                className={`tab-btn ${activeTab === 'mission' ? 'active' : ''}`}
                onClick={() => setActiveTab('mission')}
              >
                {t('about_info_tabs_mission_button')}
              </button>
              <button 
                className={`tab-btn ${activeTab === 'vision' ? 'active' : ''}`}
                onClick={() => setActiveTab('vision')}
              >
                {t('about_info_tabs_vision_button')}
              </button>
              <button 
                className={`tab-btn ${activeTab === 'history' ? 'active' : ''}`}
                onClick={() => setActiveTab('history')}
              >
                {t('about_info_tabs_history_button')}
              </button>
            </div>

            <div className="tab-content">
              <h3>{tabContent[activeTab].title}</h3>
              <p>{tabContent[activeTab].text}</p>
              <ul>
                {tabContent[activeTab].points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutInfoTabs;
